export const getDirtyFieldValues = <
  TData extends Record<keyof TDirtyItems, unknown>,
  TDirtyItems extends Record<string, unknown>,
>(
  data: TData,
  dirtyItems: TDirtyItems
): Partial<TData> => {
  const dirtyValues = Object.keys(dirtyItems).reduce((prev, key) => {
    const value = dirtyItems[key];
    if (!value) {
      return prev;
    }
    const isObject = typeof value === 'object';
    const isArray = Array.isArray(value);
    const nestedValue =
      isObject && !isArray
        ? getDirtyFieldValues(value as Record<string, unknown>, data[key] as Record<string, unknown>)
        : data[key];
    return { ...prev, [key]: isArray ? data[key] : nestedValue };
  }, {} as Partial<TData>);
  return dirtyValues;
};

type PaymentMethodFilterData = {
  paymentMethod?: string;
};

export const normalizePaymentMethodFilter = <TData extends PaymentMethodFilterData>(
  data: TData,
  shouldIncludePaymentMethod = true
): TData => ({
  ...data,
  paymentMethod:
    shouldIncludePaymentMethod && data.paymentMethod && data.paymentMethod !== 'ALL' ? data.paymentMethod : undefined,
});
